import getFile from './getFile'
import sendFile from './sendFile'

export default {
  getFile,
  sendFile,
}
